import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Não foi possível abrir o Bodyprint',
  description: 'Verifique sua conexão e tente de novo',
  reload: 'Recarregar',
  backHome: 'Voltar ao início',
} satisfies TranslationTree;
